var map = {
	"./locale-da.js": 843,
	"./locale-de.js": 844,
	"./locale-en.js": 845,
	"./locale-es.js": 846,
	"./locale-fr.js": 847,
	"./locale-id.js": 848,
	"./locale-it.js": 849,
	"./locale-pl.js": 850,
	"./locale-pt.js": 851,
	"./locale-ru.js": 852,
	"./locale-sv.js": 853,
	"./locale-zh.js": 854
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 842;


//////////////////
// WEBPACK FOOTER
// ./src/locales ^\.\/locale\-.*\.js$
// module id = 842
// module chunks = 8